import { TestQrCodeModalContent } from './TestQrCodeModalContent';
export default TestQrCodeModalContent;